import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import i18n, { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '../i18n'

export const LocaleContext = React.createContext({})
const LOCALE_KEY = 'locale'

// Mirrors ThemeContext: a per-browser preference persisted to localStorage.
export default observer(function LocaleProvider({ children }) {
  const localeState = useLocalObservable(() => {
    const savedLocale = typeof window !== 'undefined' ? localStorage.getItem(LOCALE_KEY) : null
    const initialLocale = SUPPORTED_LOCALES.includes(savedLocale) ? savedLocale : DEFAULT_LOCALE

    return {
      locale: initialLocale,
      setLocale(nextLocale) {
        if (!SUPPORTED_LOCALES.includes(nextLocale)) return

        this.locale = nextLocale
        localStorage.setItem(LOCALE_KEY, nextLocale)
      },
    }
  })

  useEffect(() => {
    i18n.changeLanguage(localeState.locale)
  }, [localeState.locale])

  return (
    <LocaleContext.Provider value={{ localeState }}>
      {children}
    </LocaleContext.Provider>
  )
})
